var selectSteps = function () { return function (state) { return state.timeline.steps; }; };
export default selectSteps;
